/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { CSSProperties } from 'react'
import { Icon } from '../utils/Icon'

export type BookmarkButtonProps = {
  onClick?: (e: any) => void
  size: number
  style?: CSSProperties
  iconStyle?: CSSProperties
}

export const BookmarkButton = ({
  onClick,
  size,
  style,
  iconStyle,
}: BookmarkButtonProps) => {
  return (
    <span
      role="button"
      onClick={onClick}
      style={style}
      css={bookmarkButtonStyle}
    >
      <Icon
        iconName="map_dialog_like"
        style={{
          display: 'block',
          height: `${size}px`,
          width: `${size}px`,
          ...iconStyle,
        }}
      />
    </span>
  )
}

const bookmarkButtonStyle = css`
  cursor: pointer;
`
